import { motion } from "framer-motion";
import { SERVICES } from "../data/content";

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-bento-grid"
      className="py-24 md:py-32 bg-[#F4F2F7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-5">
            Oferta Educativa
          </p>
          <h2 className="font-serif-display text-3xl md:text-5xl font-semibold text-[#2D1B4E] tracking-tight leading-[1.1]">
            Encuentra la carrera que mueve tu vocación.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`service-card-${i}`}
                className="group relative bg-white border border-[#E8E4EE] rounded-sm p-8 flex flex-col overflow-hidden hover:-translate-y-1 hover:border-[#C7B8E6] transition-all duration-300"
              >
                <span className="absolute left-0 top-8 bottom-8 w-[3px] bg-[#5B3E96] origin-top scale-y-0 group-hover:scale-y-100 transition-transform duration-500" />
                <div className="flex items-center justify-between">
                  <span className="flex items-center justify-center w-12 h-12 bg-[#F4F2F7] border border-[#E8E4EE] rounded-sm group-hover:bg-[#EDE8F5] transition-colors">
                    <Icon strokeWidth={1.5} className="w-6 h-6 text-[#5B3E96]" />
                  </span>
                  <span className="font-serif-display text-3xl text-[#E0D6F0] group-hover:text-[#C7B8E6] transition-colors leading-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl font-semibold text-[#2D1B4E] mt-6">
                  {s.title}
                </h3>
                <p className="text-sm text-[#5F5670] mt-3 leading-relaxed">
                  {s.desc}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
